import { createAction } from '@reduxjs/toolkit';
import { AdminMailingFormFields, AdminMailingModalVariant } from '../types';

export const setFormFields = createAction<AdminMailingFormFields>('adminMailing/setFormFields');
export const handleMailingModal = createAction<boolean>('adminMailing/handleMailingModal');
export const setMailingModalVariant = createAction<AdminMailingModalVariant>('adminMailing/setMailingModal');
